import { saveAs } from 'file-saver';

export const downloadCsv = ({ fileName, tablePayload }) => {
    if (!tablePayload) return;

    const { header = [], body = [] } = tablePayload;

    const escape = (value) => {
        if (value == null) return '';
        const str = value.toString();
        if (str.includes(',') || str.includes('"') || str.includes('\n')) {
            return `"${str.replace(/"/g, '""')}"`;
        }
        return str;
    };

    const lines = [header.map(escape).join(',')];

    for (const row of body) {
        const values = Array.isArray(row)
            ? row
            : header.map(key => row[key] ?? '');
        lines.push(values.map(escape).join(','));
    }

    // BOM para que Excel abra bien tildes y ñ
    const blob = new Blob(['\uFEFF' + lines.join('\n')], {
        type: 'text/csv;charset=utf-8;',
    });

    saveAs(blob, `${fileName?.replace(/\.csv$/i, '') || 'export'}.csv`);
};